import React from 'react'
// import spinner from '../spinner.gif'

const Loading= () =>{
    return (
      <div className='container my-3 mx-3' style={{display : 'flex', justifyContent : 'center'}}>
        <img src='./images/spinner.gif' alt="..." />
      </div>
    )
  }
  export default Loading;
